import React, { Component } from 'react';
import withRouter from "../../../Utils/withRouter";
import axios from "axios";
import Swal from "sweetalert2";
import PageTitle from "../../../Components/PageTitle";
import { ConfigContext } from "../../../Context/ConfigContext";
import { IsRequired } from '../../../Components/InputElements';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import { currentDateAndTime, decodeData ,decodeUrl,encodeData} from '../../../Constants/constants';

class Signature extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      postLoading: false,
      signatory_id: this.props.params.signatory_id ?? 0,
      signatory_name: '',
      signatory_designation: '',
      signatory_email: '',
      signatory_number: '',
      signatory_address: '',
      signatory_identification_type: '',
      signatory_authorization_level: '',
      want_approval_document: '',
      board_resolution_reference: '',
      signatory_power_of_attorney: '',
      date_of_authorization: '',
      expiry_date_of_authorization: '',
      is_there_signatory_limit: '',
      authority_limits: '',
      signatory_signature_file: null,
      signatory_signature_file_url: null,
      signatory_id: null,
      errors: {},
      decodedData: [],
      decodedDataId: '',
      row: [],

    };
    this.closeRef = React.createRef();
  }

  // componentDidMount() {
  //   console.log("this.props.params.signatory_id",this.props.params.signatory_id);
  //   if (this.state.signatory_id !== 0 && this.state.signatory_id) {
  //     // this.GetInfo(this.state.signatory_id);
  //     this.GetInfo();

  //   } else {
  //     this.resetForm();
  //   }
  // }
  componentDidMount() {
        console.log("this.props.params.signatory_id",this.props.params.signatory_id);

    this.setState({ loadingList: true, signatory_id: this.props.params.signatory_id }, (prevState) => {
      if (this.props.params.signatory_id !== 0 && this.props.params.signatory_id) {
     this.GetInfo()
      }
      else {
            this.resetForm();
          }
    });
  }

   componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedDataId = decodeUrl(encodedData);
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              // if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              //   this.setState({ decodedData });
              // }
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({encodedData,decodedDataId, decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
      getBack=()=>{
        window.history.back();
    }
  GetInfo = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSignatureInfo`, { params: { signatory_id: this.props.params.signatory_id }, headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true && data.length > 0) {
        this.setState(
          {
            signatory_id: data[0].signatory_id,
            signatory_name: data[0].signatory_name,
            signatory_designation: data[0].signatory_designation,
            signatory_email: data[0].signatory_email,
            signatory_address: data[0].signatory_address,
            signatory_identification_type: data[0].signatory_identification_type,
            signatory_authorization_level: data[0].signatory_authorization_level,
            want_approval_document: data[0].want_approval_document,
            board_resolution_reference: data[0].board_resolution_reference,
            signatory_power_of_attorney: data[0].signatory_power_of_attorney,
            date_of_authorization: data[0].date_of_authorization,
            expiry_date_of_authorization: data[0].expiry_date_of_authorization,
            is_there_signatory_limit: data[0].is_there_signatory_limit,
            authority_limits: data[0].authority_limits,
            signatory_number: data[0].signatory_number,
            signatory_signature_file: data[0].signatory_signature_file,
            signatory_signature_file_url: data[0].signatory_signature_file_url,
          }
        )
      }
    });
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;

    this.setState({ postLoading: true, })
    var formdata = new FormData();

    formdata.append('signatory_name', this.state.signatory_name);
    formdata.append('signatory_number', this.state.signatory_number);
    formdata.append('signatory_designation', this.state.signatory_designation);
    formdata.append('signatory_email', this.state.signatory_email);
    formdata.append('signatory_address', this.state.signatory_address);
    formdata.append('signatory_identification_type', this.state.signatory_identification_type);
    formdata.append('signatory_authorization_level', this.state.signatory_authorization_level);
    formdata.append('want_approval_document', this.state.want_approval_document);
    formdata.append('board_resolution_reference', this.state.board_resolution_reference);
    formdata.append('signatory_power_of_attorney', this.state.signatory_power_of_attorney);
    formdata.append('date_of_authorization', this.state.date_of_authorization);
    formdata.append('expiry_date_of_authorization', this.state.expiry_date_of_authorization);
    formdata.append('is_there_signatory_limit', this.state.is_there_signatory_limit);
    formdata.append('authority_limits', this.state.authority_limits);
    formdata.append('signatory_signature_file', this.state.signatory_signature_file);
    formdata.append('date' ,currentDateAndTime());
    formdata.append('signatory_id', this.state.signatory_id);

    

    // if (!this.state.signatory_id) {
    //   formdata.append('signatory_id', this.state.signatory_id);
    // }

    axios.post(`${apiURL}Masters/CreateSignature`, formdata, { headers }).then((response) => {
      const { success } = response.data;
      this.setState({ postLoading: false, })
      if (success === true) {
        this.resetForm();
        setTimeout(() => {
          if (this.state.signatory_id) {
            this.closeRef.current.click();
          }
        }, 1000);
        this.setState({ postLoading: false });
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      } else {
        this.setState({ postLoading: false });
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
            allowOutsideClick: false,
        });
      }

    })
  };

  resetForm = () => {
    this.setState({
      postLoading: false,
      signatory_id: 0,
      signatory_name: '',
      signatory_number: '',
      signatory_designation: '',
      signatory_email: '',
      signatory_address: '',
      signatory_identification_type: '',
      signatory_authorization_level: '',
      want_approval_document: '',
      board_resolution_reference: '',
      signatory_power_of_attorney: '',
      date_of_authorization: '',
      expiry_date_of_authorization: '',
      is_there_signatory_limit: '',
      authority_limits: '',
      signatory_signature_file: null,
      signatory_signature_file_url: null,
      errors: {}
    });
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleInputChange = (e) => {
    const { name, value, type } = e.target;
    const newValue = type === 'file' ? e.target.files[0] : value;
    this.setState((prevState) => ({
      [name]: newValue,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  ViewLogo = () => {
    Swal.fire({
      title: 'Signatory',
      html: `<img src='${this.state.signatory_signature_file_url}' style="max-width: 100%;" />`,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  };

  validateForm = () => {
    const errors = {};

    // set form errors
    if (!this.state.signatory_name) {
      errors.signatory_name = 'Signatory Name is required';
    }
    if (!this.state.signatory_designation) {
      errors.signatory_designation = 'Signatory Designation is required';
    }
    if (!this.state.signatory_email) {
      errors.signatory_email = 'Signatory Email is required';
    } else if (!/\S+@\S+\.\S+/.test(this.state.signatory_email)) {
      errors.signatory_email = 'Signatory Email is invalid';
    }
    if (!this.state.signatory_number) {
      errors.signatory_number = 'Signatory Number is required';
    }
    if (!this.state.signatory_address) {
      errors.signatory_address = 'Signatory Address is required';
    }
    if (!this.state.signatory_identification_type) {
      errors.signatory_identification_type = 'Signatory Identification Type is required';
    }
    if (!this.state.signatory_authorization_level) {
      errors.signatory_authorization_level = 'Signatory Authorization Level is required';
    }
    if (!this.state.signatory_signature_file && this.state.signatory_id === 0) {
      errors.signatory_signature_file = 'Signatory signature file is required';
    } else if (this.state.signatory_signature_file.size > 2 * 1024 * 1024 && this.state.signatory_id === 0) {
      errors.signatory_signature_file = 'Signatory signature file size should not exceed 2MB';
    }

    return errors;
  };

  render() {
    const { errors, signatory_id } = this.state;
    //Signatory Authorization Level array
    const signatory_authorization_level = [
      { value: 'Full', label: 'Full' },
      { value: 'Limited', label: 'Limited' },
    ];
    const signatory_identification_type = [
      { value: 'Aadhar', label: 'Aadhar' },
      { value: 'PAN', label: 'PAN' },
    ];
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={signatory_id === 0 ? `Create Signature` : 'Update Signature'} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div>
                  </div>
                  <div className="container mt-2 p-2">
                    <form>
                      <div className="row mb-5 mt-2">
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label htmlFor="signatory_name" className="form-label">Signatory Name <IsRequired />:</label>
                            <input
                              type="text"
                              id="signatory_name"
                              name="signatory_name"
                              value={this.state.signatory_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Signatory Name"
                            />
                            {errors.signatory_name && <div className="invalid-feedback">{errors.signatory_name}</div>}
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="signatory_designation" className="form-label">Signatory Designation. <IsRequired /> :</label>
                            <input
                              type="text"
                              id="signatory_designation"
                              name="signatory_designation"
                              value={this.state.signatory_designation}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_designation ? 'is-invalid' : ''}`}
                              placeholder="Enter Signatory Designation."
                            />
                            {errors.signatory_designation && <div className="invalid-feedback">{errors.signatory_designation}</div>}
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="signatory_signature_file" className="form-label">Signatory Signature Upload <IsRequired />:</label>
                            <a
                              //  href={`${this.state.signatory_signature_file_url}`}
                              className={`${!this.state.signatory_signature_file_url ? ('d-none') : ''} link-info link-offset-2 link-underline-opacity-100-hover fs-10`}
                              style={{ float: 'right', cursor: 'pointer' }}
                              // target="_blank" rel="noopener noreferrer"
                              onClick={this.ViewLogo}
                            >
                              View Uploaded Signature
                              <i className="ri-arrow-right-line label-icon align-middle fs-16" />
                            </a>
                            <input
                              type="file"
                              id="signatory_signature_file"
                              name="signatory_signature_file"
                              accept=".jpg, .png, .jpeg"
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_signature_file ? 'is-invalid' : ''}`}
                            />
                            {errors.signatory_signature_file && <div className="invalid-feedback">{errors.signatory_signature_file}</div>}
                            {/* </div> */}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label htmlFor="signatory_email" className="form-label">Signatory Email Address <IsRequired /> :</label>
                            <input
                              type="email"
                              id="signatory_email"
                              name="signatory_email"
                              value={this.state.signatory_email}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_email ? 'is-invalid' : ''}`}
                              placeholder="Enter Signatory Email Address"
                            />
                            {errors.signatory_email && <div className="invalid-feedback">{errors.signatory_email}</div>}
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="signatory_number" className="form-label">Signatory Contact Number. <IsRequired /> :</label>
                            <input
                              type="number"
                              id="signatory_number"
                              name="signatory_number"
                              value={this.state.signatory_number}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_number ? 'is-invalid' : ''}`}
                              placeholder="Enter Signatory Contact Number."
                            />
                            {errors.signatory_number && <div className="invalid-feedback">{errors.signatory_number}</div>}
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="signatory_authorization_level" className="form-label">Signatory Authorization Level<IsRequired /> :</label>
                            <Select onChange={(selectedOption) => this.handleSelectChange('signatory_authorization_level', selectedOption)} placeholder={`Select Signatory Authorization Level`} options={signatory_authorization_level} value={this.state.signatory_authorization_level ? signatory_authorization_level.find(option => option.value === this.state.signatory_authorization_level) : null} />
                            {errors.signatory_authorization_level && <div className="text-danger">{errors.signatory_authorization_level}</div>}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-4">
                            <label htmlFor="signatory_identification_type" className="form-label">Signatory Identification Type<IsRequired /> :</label>
                            <Select onChange={(selectedOption) => this.handleSelectChange('signatory_identification_type', selectedOption)} placeholder={`Select Signatory Identification Type`} options={signatory_identification_type} value={this.state.signatory_identification_type ? signatory_identification_type.find(option => option.value === this.state.signatory_identification_type) : null} />
                            {errors.signatory_identification_type && <div className="text-danger">{errors.signatory_identification_type}</div>}
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="signatory_address" className="form-label">Signatory Address<IsRequired /> :</label>
                            <textarea
                              id="signatory_address"
                              name="signatory_address"
                              value={this.state.signatory_address}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.signatory_address ? 'is-invalid' : ''}`}
                              placeholder="Enter Signatory signatory_address"
                            />
                            {errors.signatory_address && <div className="invalid-feedback">{errors.signatory_address}</div>}
                          </div>
                        </div>
                      </div>
                    </form>
                    {!signatory_id ? (
                      <div className="d-flex gap-3 justify-content-end">
                         <button className="btn btn-light btn-label waves-effect right waves-light"  
                        //  to={"/SignatoryMaster"}
                                        onClick={()=> this.getBack()} >
                                            <i className="ri-list-check label-icon align-middle fs-16 ms-2" /> List
                                        </button>
                        {/* <NavLink to={"/SignatoryMaster"} ref={this.closeRef} type="button" disabled={this.state.postLoading} onClick={this.resetForm} className="btn btn-light btn-label waves-effect right waves-light" style={{ marginRight: "10px" }}> */}
                         {/* <NavLink to={`/SignatoryMaster?abs=${encodeData(this.state.decodedDataId)}`}>

                        
                          <i className="ri-list-check label-icon align-middle fs-16 ms-2" /> List
                        </NavLink> */}
                        <button type="button" disabled={this.state.postLoading} 
                        onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect right waves-light">
                          <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" /> Create
                        </button>
                      </div>
                    ) : 
                    <div className="d-flex gap-3 justify-content-end">
                      <button type="button" className="btn btn-success btn-label waves-effect right waves-light" onClick={this.handleSubmit}>
                        <i className=" ri-edit-box-line label-icon align-middle fs-16 ms-2" /> Updated
                      </button>
                      {/* <NavLink to={"/SignatoryMaster"} ref={this.closeRef} type="button" disabled={this.state.postLoading} onClick={this.resetForm} className="btn btn-light btn-label waves-effect right waves-light" style={{ marginLeft: "10px" }}> */}
                      {/* <NavLink to={`/SignatoryMaster?abs=${encodeData(this.state.decodedDataId)}`}>

                        <i className="ri-close-fill label-icon align-middle fs-16 ms-2" /> Cancel
                      </NavLink> */}
                      <button className="btn btn-success btn-sm" 
                        onClick={()=> this.getBack()}
                        ><i className="bx bx-list-ul label-icon align-middle fs-4 " />
                      </button>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >

    );
    
  }
}

export default withRouter(Signature);
